<template>
     <Button type="chat">
        <div v-if="lastMessage && lastMessage.message">
            <span v-if="!lastMessage.seen" ></span>
            <Icon icon="dashboard-chat-icon" />
        </div>
    </Button>
</template>

<script>
import Button from '../../Button'
import Icon from '../../../../../components/Theme/Icon'
import {useLastMessage} from '../../../../../core/hooks'
import { watch } from '@vue/composition-api'

export default {
    name: 'ChatIcon',
    components: {
        Button,
        Icon
    },
    props: {
      request: Object  
    },
    setup(props, context){
        const {lastMessage} = useLastMessage(props.request);

        watch(lastMessage, (message) => { 
            if(message) {
                context.emit('setRequestData', props.request.id, {
                    key: 'messageData',
                    value: message
                });
            }
        })

        return {
            lastMessage
        }
    }
}
</script>
<style lang="scss" scoped>
span {
    display: block;
    position: relative;
    &::after {
        position: absolute;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: red;
        right: 0;
        top: 0;
        transform: translate(2px, 2px);
    }
}
</style>